export const carouselWrapper =
  'w-full md:w-fit md:max-w-[41%] md:flex-[0_0_41%]'
export const contentWrapper =
  'w-full md:w-fit md:ml-32 p-4 md:p-0 md:flex-[0_0_33%]'
